import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    body: Yup.string().required("Body is required"),
    buttons: Yup.array().of(
      Yup.object().shape({
        value: Yup.string().required("Button Title is required"),
      })
    ),
  }),
  mapPropsToValues: (props) => ({
    body: "",
    buttons: [],
  }),
  handleSubmit: (values) => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true,
});

export default formikEnhancer;
